<template>
  <div class="magazine-mobile-category-links">
    <!-- First two category links -->
    <div
      class="flex gap-2 overflow-x-auto scrollbar-hide -mx-4 px-4"
      style="webkitoverflowscrolling: touch"
    >
      <NuxtLink
        v-for="category in categories"
        :key="category.slug"
        v-slot="{ navigate }"
        :to="localePath(`/magazine/${category.slug}`)"
        custom
      >
        <Chip
          :selected="isCurrentCategory(category.slug)"
          :classes="'!m-0'"
          @click="navigate"
        >
          <span class="text-xs font-medium whitespace-nowrap flex-shrink-0">{{
            category.name
          }}</span>
        </Chip>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import Chip from '~/components/common/Chip.vue'

const route = useRoute()
const $localePath = useLocalePath()
const localePath = $localePath

// Provide the required injected values for FilterItem
const isFilterOpen = ref(false)
const activeFilterItemId = ref(null)

provide('isFilterOpen', isFilterOpen)
provide('activeFilterItemId', activeFilterItemId)

// Define props
interface Category {
  slug: string
  name: string
  icon?: string | null
  count?: number
}

defineProps<{
  categories: Category[]
}>()

// Check if a category is currently active
const isCurrentCategory = (categorySlug: string) => {
  return route.params.articleSlug === categorySlug
}
</script>

<style lang="postcss" scoped>
.magazine-mobile-category-links {
  @apply relative;
}
</style>
